import { createAction } from "@ngrx/store";

import { SportsbookBlockUpdate } from "./sportsbook-block.model";

export namespace SportsbookBlockAction {
	const ACTION_PREFIX = "[Sportsbook Block]";

	export const update = createAction(`${ACTION_PREFIX} Update`, (sportsbookBlockUpdate: SportsbookBlockUpdate) => ({
		sportsbookBlockUpdate,
	}));

	export const postpone = createAction(`${ACTION_PREFIX} Postpone`);
	export const clear = createAction(`${ACTION_PREFIX} Clear`);
}
